<template>
  <div class="container">
    <section>
      <h2>完成带面任务</h2>
      <a class="close" @click="closePage"
        ><a-icon style="font-size:30px;color:#666" type="close-circle"
      /></a>
      <a-form-model
        class="ruleForm"
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="是否到面" prop="is_interview">
          <a-radio-group v-model="ruleForm.is_interview">
            <a-radio :value="1">否</a-radio>
            <a-radio :value="2">是</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="面试结果" prop="interview_result">
          <a-radio-group v-model="ruleForm.interview_result">
            <a-radio :value="1">通过</a-radio>
            <a-radio :value="2">未通过</a-radio>
            <!-- <a-radio :value="3">等待结果</a-radio> -->
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="性格标签" prop="resume_character">
          <a-checkbox-group v-model="ruleForm.resume_character">
            <a-checkbox v-for="item in characters" :key="item" :value="item">{{
              item
            }}</a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 14, offset: 10 }">
          <a-button type="primary" @click="onSubmit">
            提交
          </a-button>
        </a-form-model-item>
      </a-form-model>
    </section>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      labelCol: { span: 5 },
      wrapperCol: { span: 16 },
      ruleForm: {
        is_interview: "",
        interview_result: "",
        resume_character: []
      },
      rules: {
        is_interview: [
          {
            required: true,
            message: "请选择是否到面",
            trigger: "change"
          }
        ],
        interview_result: [
          {
            required: true,
            message: "请选择面试结果",
            trigger: "change"
          }
        ],
        resume_character: [
          {
            required: true,
            message: "请选择性格标签",
            trigger: "change"
          }
        ]
      },
      characters: [
        "外向",
        "老实",
        "好学",
        "热情",
        "勤奋",
        "滑头",
        "自私",
        "易怒",
        "冷漠",
        "迟钝"
      ]
    };
  },
  props: {
    finishTaskID: null
  },
  methods: {
    closePage() {
      this.$emit("hideIsFinishTask", false);
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url =
            this.httpsBasic.url +
            this.httpsBasic.resume +
            "Resume_task/inviteFinished";
          // console.log(this.ruleForm);
          let params = {
            resume_task_id: this.finishTaskID,
            is_interview: this.ruleForm.is_interview,
            interview_result: this.ruleForm.interview_result,
            resume_character: JSON.stringify(this.ruleForm.resume_character),
            token: window.localStorage.getItem("xnwfPcToken")
          };
          //   console.log(params);
          axios.post(url, params).then(res => {
            if (res.data.code == 200) {
              this.$message.success("提交成功");
              this.$refs.ruleForm.resetFields();
              this.$emit("hideIsFinishTask", true);
            } else {
              this.$message.error(res.data.message);
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.container {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1;
  > section {
    background: #fff;
    position: absolute;
    top: 20%;
    left: 30%;
    min-width: 40%;
    padding: 30px 4% 10px;
    border-radius: 10px;
    h2 {
      text-align: center;
      font-size: 18px;
      margin-bottom: 10px;
    }
    .close {
      position: absolute;
      right: 14px;
      top: 10px;
    }
  }
}
</style>
